import * as React from "react";
const SvgFacebookPadding = () => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m19.86 17.279.453-2.878h-2.79v-1.87c0-.787.39-1.555 1.635-1.555h1.286v-2.45a15.6 15.6 0 0 0-2.264-.194c-2.296 0-3.795 1.38-3.795 3.875v2.194H11.84v2.878h2.545v6.96h3.138v-6.96z"
  }
));
export default SvgFacebookPadding;
